export const de_CH = {
  pricing_table: {
    year: "Jahr",
    month: "Monat",
    upon_request: "Auf Anfrage",
    monthly: "Monatlich",
    annual: "Jährlich",
    paid_annually: "jährlich abgerechnet",
    currency_label: "Währung",
    language_label: "Sprache",
    billing_label: "Abrechnung",
    change_your_subscription: "Wechseln zu Jahresabo",
    request_now: "Jetzt anfragen",
    upgrade_now: "Jetzt upgraden",
    contact_support: "Support kontaktieren",
    manage_user_profile: "Konfiguriere deinen Plan",
    change_number_of_user: "Ressourcen",
    change_number_of_group_appointment: "Gruppentermine",
    change_number_of_store: "Standorte",
    change_number_of_conference: "Konferenzen",
    per_month_above_tier_min: "/Mo. je oberhalb des Tarifminimums",
    sales_calculator_title: "Sales-Rechner",
    sales_calculator_subtitle: "Wähle den günstigsten passenden Tarif; Stückkosten gelten oberhalb des jeweiligen Minimums.",
    per_user_calender: "Benutzer",
    per_user_calenders: "Benutzer",
    per_group_appointment: "Gruppentermin",
    per_group_appointments: "Gruppentermine",
    per_store: "Filiale",
    per_stores: "Filialen",
    per_conference: "Konferenz",
    per_conferences: "Konferenzen",
    price_on_request: "Preis auf Anfrage",
    base: "Basis",
    charged_monthly: "monatlich abgerechnet",
    charged_annually: "jährlich abgerechnet",
    best_value: "Am beliebtesten",
    active: "Aktiv",
    persona_basic: "Für Solo-Selbstständige",
    persona_starter: "Für kleine Teams",
    persona_team: "Für wachsende Teams",
    persona_enterprise: "Für grosse Organisationen",
    you_also_unlock: "Du erhältst zusätzlich mit",
    hero_eyebrow: "Pläne & Preise",
    hero_title_lead: "Wähle den Plan, der",
    hero_title_accent: "mit dir wächst.",
    hero_subtitle: "DSGVO-konforme Online-Terminbuchung, die mit dir wächst — von der ersten Buchung bis zur Enterprise-Lösung.",
    compare_all_features: "Alle Funktionen vergleichen",
    total: "Total",
    close: "Schliessen",
    calenso_pricing: "{{brandName}} Preisrechner",
    rights_reserved: "Alle Rechte vorbehalten, <a href='{{websiteUrl}}' target='_blank'>{{brandName}}</a> {{ year }}."
  },
  pricing_compare: {
    hide_comparison: "Funktionsvergleich ausblenden",
    feature_column: "Funktion"
  },
  pricing_addons: {
    section_title: "On-Demand Add-ons",
    section_subtitle: "Spezialisierte Funktionen, die in allen Tarifen verfügbar sind. Jedes Add-on schaltet eine bestimmte Funktion frei — kontaktiere den Support, um es für dein Konto zu aktivieren.",
    contact_cta: "Support kontaktieren",
    from_price: "ab",
    active_badge: "Aktiv",
    active_label: "In deinem Tarif aktiv",
    analytics_name: "Analytics",
    analytics_description: "Erweitertes Buchungs-Analytics-Dashboard mit detaillierten Statistiken und Reports.",
    room_booking_name: "Raumbuchung",
    room_booking_description: "Dedizierte Buchung für Räume und Meetingbereiche zusätzlich zur regulären Terminbuchung.",
    customer_otp_name: "Widget-Kunden-OTP",
    customer_otp_description: "Einmalpasswort-Verifizierung für Kunden, die über das öffentliche Widget buchen.",
    timezone_name: "Zeitzonen-Unterstützung",
    timezone_description: "Multi-Zeitzonen-Support mit Partner-/Mitarbeitenden-/Kunden-Zeitzonen-Hierarchie.",
    read_customers_widget_name: "Kunden im Widget laden",
    read_customers_widget_description: "Das öffentliche Widget liest Kundendaten per UUID und füllt persönliche Informationen vor.",
    multi_partner_worker_name: "Multi-Partner-Mitarbeitende",
    multi_partner_worker_description: "Mitarbeitende mit derselben E-Mail-Adresse können mehreren Partnern zugeordnet werden — nützlich für Franchise- und Multi-Brand-Setups.",
    resource_planning_name: "Ressourcenplanung",
    resource_planning_description: "Vordefinierte Terminslots, die von Admins für planbare Ressourcenbelegung erstellt werden.",
    hubspot_name: "HubSpot-Integration",
    hubspot_description: "HubSpot CRM-Synchronisation für Kontakte, Unternehmen und Termine.",
    user_sync_name: "User Sync (Entra ID)",
    user_sync_description: "Microsoft Entra ID (Azure AD) Synchronisation mit Filial-Mitarbeitenden-Mapping.",
    dynamic_combi_name: "Dynamische Kombi-Services",
    dynamic_combi_description: "Mehrstopp-Tourbuchungen mit gerichteter Wegzeitmatrix und Service-bezogenem Routing.",
    graph_api_logging_name: "Microsoft Graph API-Logging",
    graph_api_logging_description: "Umfassendes Logging aller Microsoft-Graph-API-Aktivitäten für Compliance und Audit.",
    condition_engine_name: "Condition Engine",
    condition_engine_description: "Erweiterte Bedingungslogik aufbauend auf der Workflow-Engine — Verzweigungsregeln, mehrkriterielle Trigger und dynamische Platzhalter."
  }
};
